<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/establish/contractlist',title:'返利管理'},{title:'返利计算预提'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <!--查询表单-->
            <div class="h-piece">
                    <!-- <div class="h-pieceTitle2" style="margin-bottom:0.2rem">
                        <h1>预提</h1>
                    </div> -->
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
						<div class="h-formBox w-formBox one-formBox">
							<el-form-item  label="展示时间" class="nianboxs" v-if="check1">
							    <el-date-picker
									style="width: 100%;"
							            v-model="q.date"
							            :clearable="true"
							            type="month"
							            value-format="yyyy-MM"
							            placeholder="选择日期">
							    </el-date-picker>
							</el-form-item>
							<el-form-item class="right-btn">
								<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
								<el-button class="h-btn h-formBtn h-bgwhite" @click="qingkong">重置</el-button>
							</el-form-item>
						</div>
                    </el-form>
            </div>


            <div class="" style="margin-top: 0.3rem;">
                <div class="h-formBox">
                    <!-- <div class="h-pieceTitle2" style="margin-bottom:0.2rem">
                        <h1>预提</h1>
                    </div> -->
                    <el-table @selection-change="handleSelectionChange"
                            ref="yttable"
                            :data="yttable"
                            stripe
                            style="width: 100%"
                           :border="true"
						   max-height="450"
                    >
                        <el-table-column
								fixed
                                type="selection"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
								fixed
                                label="#"
                                width="40">
                        </el-table-column>
                        <el-table-column
                                prop="fiBookCode"
                                label="入账公司编码"
								:show-overflow-tooltip="true"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                prop="weidui"
                                label="累计未兑"
								:show-overflow-tooltip="true"
                                width="100">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.weidui}}
										</div>
									</template>
                        </el-table-column>


                        <el-table-column
                                prop="monthfl"
                                label="月度计算"
								:show-overflow-tooltip="true"
                                width="100">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.monthfl}}
										</div>
									</template>
                        </el-table-column>
                        <!--<el-table-column-->
                                <!--prop="jiduJisuan"-->
                                <!--label="季度计算"-->
                                <!--width="170">-->
                        <!--</el-table-column>-->

                        <el-table-column
                                prop="monthyt"
                                label="季度计算"
								:show-overflow-tooltip="true"
                                width="100">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.monthyt}}
										</div>
									</template>
                        </el-table-column>

                      <el-table-column
                          prop="yearfl"
                          label="年度计算"
                          :show-overflow-tooltip="true"
                          width="100">
                        <template slot-scope="scope">
                          <div style="text-align: right;">
                            {{scope.row.yearfl}}
                          </div>
                        </template>
                      </el-table-column>

                        <el-table-column
                                prop="accrualAmt"
                                label="本月预提(不含税)"
								:show-overflow-tooltip="true"
                                width="150">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.accrualAmt}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                prop="text"
                                label="固定值"
								:show-overflow-tooltip="true"
                                width="140">
                        </el-table-column>
                        <el-table-column
                                prop="currencyCode"
                                label="币种编码"
								:show-overflow-tooltip="true"
                                width="90">
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                label="状态"
								:show-overflow-tooltip="true"
                                width="80">
                            <template slot-scope="scope">
                                <dictname category="yuti_gems_status" :v="scope.row.status"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="successFlag"
                                label="成功标志"
								:show-overflow-tooltip="true"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="msg"
                                label="返回信息"
                                width="170"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="docNo"
                                label="GEMS预提单号"
								:show-overflow-tooltip="true"
                                width="170">
                        </el-table-column>
                        <el-table-column
                                prop="voucherNo"
                                label="SAP凭证号"
								:show-overflow-tooltip="true"
                                width="170">
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="80"
                        >
                            <template slot-scope="scope">
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="chakan(scope.row)">查看
                                </el-button>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
            </div>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               @click="exportExcelGems" v-auth="'yuti_daochu'">批量导出
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ"
                               @click="updateGems" v-auth="'fl_chuanGems'">传Gems
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ"
                               @click="updateGemsNew" v-auth="'fl_chuanGems'">传报账中心
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ"
                               @click="updateHeji" v-auth="'fl_gengxin'">更新合计
                    </el-button>
                </div>
                <div class="h-pagination2">
                    <pagination :page="q" @query="query"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'

    export default {
        components: {},
        data() {
            return {
                check1: true,
                value1: '',
                yttable: [],
                //表格
                multipleSelection: [],
                fljsstyle: [
                    {
                        value: 1,
                        label: '月度'
                    },
                    {
                        value: 2,
                        label: '季度'
                    },
                ],
                timeValue: null,
                value2: '',
                showhistory: false,
                instid: '',
                taskid: '',
                //查询属性
                page: {
                    contractBaseId: '',
                    pageSize: 20,
                    pageNo: 1
                },
                q: {
                    styles: '',
                    contractNameLike: '',
                    startCdate: '',
                    endCdate: '',
                    taskid: '',
                    date: '',
                    type: '',
                    agentNameLike: '',
                    agentCodeLike:'',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },

                //表单
                f: {
                    pageNo: 1,
                    id: null, //
                    contractBaseId: null, //
                    agentName: null, //
                    agentCode: null, //
                    productType: null, //
                    contractEndTime: null, //
                    goal: null,//目标
                    salesVolume: null,//销额
                    rebateBase: null,//基数
                    rebateAmount: null,//返利
                    newRebateAmount: null,//返利
                    completionRate: null, //
                    areaCode: null, //
                    area: null, //
                    channelCode: null, //
                    channel: null, //
                    cdate: null, //
                    ldate: null, //
                    cucode: null, //
                    cuname: null, //
                    lucode: null, //
                    delflag: null, //
                },

                //table列表
                tableData: [],
                flag: 0,
                //操作标志
                optflag: 'save',
            }
        },
        created() {
            this.query();
            this.getYuti();
        },
        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },
        methods: {
            updateGems() {
                this.$msg.confirm("确认传GEMS?", () => {
                    var idlist = [];
                    this.multipleSelection.forEach(element => {
                        idlist.push(element.id);
                        console.log(idlist);
                    });
                    this.q.idlist = idlist;
                    ss.fanli.updateGems(this.q).then(rd => {
                        console.log(this.q, 'GEMS数据！！！！！！！！！！！！！')
                        console.log(rd, 'GEMS数据')
                        this.$msg.msgs(rd.msg);
                        this.getYuti();
                    })
                });
            },
            updateGemsNew() {
                this.$msg.confirm("确认传报账中心?", () => {
                    var idlist = [];
                    this.multipleSelection.forEach(element => {
                        idlist.push(element.id);
                        console.log(idlist);
                    });
                    this.q.idlist = idlist;
                    ss.fanli.updateGemsNew(this.q).then(rd => {
                        console.log(this.q, '报账中心数据！！！！！！！！！！！！！')
                        console.log(rd, '报账中心数据')
                        this.$msg.msgs(rd.msg);
                        this.getYuti();
                    })
                });
            },
            updateHeji() {
                this.$msg.confirm("确认重新计算月度返计算数值?", () => {
                    ss.fanli.updateHeji(this.q).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.getYuti();
                    })
                });
            },
            getYuti() {
              this.q.idlist = null;
              console.log(this.q, 'abcdefg')
                ss.fanli.getYuti(this.q).then(rd => {
                    this.yttable = rd.records;
                    this.q.total = rd.total;
                    console.log(this.yttable)
                })
            },
            //重置
            qingkong() {
                this.q.date = '';
                this.q.fiBookCodeLike = '';
            },


            query() {

            },

            handleFilter() {
               this.getYuti();
            },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
                console.log(this.multipleSelection, "WWWWWWWWWW")
            },
            // //返利批量导出
            // exportExcel() {
            //     var idlist = [];
            //     this.multipleSelection.forEach(element => {
            //         idlist.push(element.id);
            //     });
            //     if (idlist.length != 0) {
            //         updownfile.down("/api/swyl/v1/demo/viewFlAgentTarget/downloadExcelId", idlist, "post", 'data');
            //     } else {
            //         updownfile.down("/api/swyl/v1/demo/viewFlAgentTarget/downloadExcelEntity", this.q, "post");
            //     }
            //
            // },
            // //开票明细批量导出
            // exportExcelDetail() {
            //     var idlist = [];
            //     this.multipleSelection.forEach(element => {
            //         idlist.push(element.id);
            //     });
            //     if (idlist.length != 0) {
            //         updownfile.down("/api/swyl/v1/demo/viewFlAgentTarget/downloadExcelIdDetail", idlist, "post", 'data');
            //     } else {
            //         updownfile.down("/api/swyl/v1/demo/viewFlAgentTarget/downloadExcelEntityDetail", this.q, "post");
            //     }
            //
            // },
            //预提批量导出
            // exportExcelGems() {


               // updownfile.down("/api/swyl/v1/demo/flJemsYuti/downloadExcel", "post");
            // },
            //开票明细批量导出
            exportExcelGems() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    console.log(this.q.type+"@@@@@@@@");
                    // idlist.push(
                    //     {
                    //         id: element.id+","+this.q.type+","+this.q.rebateChainGroup,
                    //     }
                    // );
                    idlist.push(element.id);
                    console.log(idlist);
                });
                if (idlist.length != 0) {
                    console.log(idlist);
                    updownfile.down("/api/swyl/v1/demo/flJemsYuti/downloadExcelById", idlist, "post", 'data');
                } else {
                    updownfile.down("/api/swyl/v1/demo/flJemsYuti/downloadExcel", this.q, "post");
                }

            },


            //点击查看详情
            chakan(item) {
                console.log('行', item)
                console.log('行11111', item.fiBookCode)
                this.$router.push({
                    path: '/establish/etYuTiList',
                    query: {
                        fiBookCode: item.fiBookCode,
                        year: item.year,
                        month: item.month
                    }
                });
            },
        }
    }
</script>
